import React, {useState, useEffect, useMemo} from "react";

// ------------ Lib ------------------
import _ from "lodash";

// ------------ Components ------------
import {Modal} from "@redq/reuse-modal";
import {Row, Col, Button, Form, Collapse, Dropdown} from "react-bootstrap";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import {
    Map,
    Marker,
    InfoWindow,
	Polyline
} from "google-maps-react";
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import MultiSelect from 'multiselect-react-dropdown';

// -------------- APIs ---------------
import API from "../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import {
	Box,
	ExpansionPanel, ExpansionPanelDetails,
	ExpansionPanelSummary, IconButton,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";

let getLat;
let getLng;

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
	padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const labelStyle = {
    lineHeight: "2.5rem",
    width: "110px"
};

const currentDate = moment(new Date()).format("YYYY-MM-DD");

const mapStyles = [
	{
		featureType: "administrative",
		elementType: "geometry",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "administrative.land_parcel",
		elementType: "labels",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "poi",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "labels.text",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "road",
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "labels",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "transit",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
];

const OrderMap = (props) => {
	var bounds = null;

	// --------------- States ------------------
	const [latitude, setLatitude] = useState(11.5564);
	const [longitude, setLongitude] = useState(104.9282);
	const [orderList, setOrderList] = useState([]);
	const [isRequesting, setIsRequesting] = useState(false);
	const [status, setStatus] = useState(234568);
	const [fromDate, setFromDate] = useState(currentDate);
	const [selectedStatus, setSelectedStatus] = useState();
	const [timeSlot, setTimeSlot] = useState([
		{label: "10:00 - 11:00", start: "10:00", end: "11:00"},
		{label: "11:00 - 12:00", start: "11:01", end: "12:00"},
		{label: "12:00 - 13:00", start: "12:01", end: "13:00"},
		{label: "13:00 - 14:00", start: "13:01", end: "14:00"},
		{label: "14:00 - 15:00", start: "14:01", end: "15:00"},
		{label: "15:00 - 16:00", start: "15:01", end: "16:00"},
		{label: "16:00 - 17:00", start: "16:01", end: "17:00"},
		{label: "17:00 - 18:00", start: "17:01", end: "18:00"},
		{label: "18:00 - 19:00", start: "18:01", end: "19:00"},
		{label: "19:00 - 20:00", start: "19:01", end: "20:00"},
		{label: "20:00 - 21:00", start: "20:01", end: "21:00"},
	]);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [timeOptions, setTimeOptions] = useState();
	const [isDisabled, setIsDisabled] = useState(false);
	const [orderStatusOpts, setOrderStatusOpts] = useState([
		{
			label: "All status",
			value: {status: 234568, isShowAccptedHasDriver: false},
		},
		{label: "New", value: {status: 2, isShowAccptedHasDriver: false}},
		{label: "Accepted", value: {status: 3, isShowAccptedHasDriver: false}},
		{
			label: "Packed & Dispatched",
			value: {status: 45, isShowAccptedHasDriver: false},
		},
		{label: "Delivered", value: {status: 6, isShowAccptedHasDriver: false}},
		{label: "Arrived", value: {status: 8, isShowAccptedHasDriver: false}},
	]);

	const [activeMarker, setActiveMarker] = useState({});
	const [showingInfoWindow, setShowingInforWindow] = useState(false);
	const [selectedOrder, setSelectedOrder] = useState({});
	const [textSearch, setTextSearch] = useState("");
	const [mapZoom, setMapZoom] = useState(14);
	const [searchString, setSearchString] = useState("");
	const [isSearching, setIsSearching] = useState(false);

	// google-maps-react compares `center` by identity and calls map.setCenter() whenever
	// it changes. A fresh object literal each render meant every state update -- opening
	// an InfoWindow included -- yanked the map back. Memoized, the map only moves when
	// the coordinates themselves change (search, driver log entry).
	const mapCenter = useMemo(() => ({lat: latitude, lng: longitude}), [latitude, longitude]);

	//filter button
	const [collapse, setCollapse] = useState(false);
	// driver State for call api
	const [driverInfo, setDriverInfo] = useState([]);
	//set driverLocation
	const [driverLocation, setDriverLocation] = useState([]);
	//set warehouse location
	const [warehouse, setWarehouse] = useState(null);
	const [driverStartTime, setDriverStartTime] = useState("");
	const [driverEndTime, setDriverEndTime] = useState("");
	// const [selectedDrivers, setSelectedDrivers] = useState([]);
	const [selectedDrivers, setSelectedDrivers] = useState([]);
	//check which marker is active

	//driver State for infowindow
	const [activeMarkers, setActiveMarkers] = useState(null);
	const [selectedPlace, setSelectedPlace] = useState({});
	const [selectedDriverLogs, setSelectedDriverLogs] = useState([]);
	const [showDriverLogsModal, setShowDriverLogsModal] = useState(false);
	const [driverMarkerPosition, setDriverMarkerPosition] = useState(null);
	const [showingInfoWindows, setShowingInfoWindows] = useState(false);

	//  ------------------- Method ----------------
	const getOrderList = (param) => {
		setIsRequesting(true);
		let tmpStatus = _.clone(status);
		let tmpNumber = tmpStatus
			.toString()
			.split("")
			.map((x) => parseInt(x));
		let statusList = tmpNumber;

		let query = {
			statusList: JSON.stringify(statusList),
			fromDate,
			timeOptions
		};

		API.getOrderBasicList(query)
			.then((response) => response.json())
			.then((response) => {
				setIsRequesting(false);
				setIsDisabled(false);
				if (response.success) {
					setOrderList(response.data);
				}
			});
	};

	useEffect(() => {
		setOrderList([]);
		getOrderList();
	}, [status, fromDate, timeOptions]);

	const handleSelectOrderStatus = (e) => {
		let data = orderStatusOpts[e.target.value].value;
		setStatus(data.status);

		if (showingInfoWindow) {
			setActiveMarker(null);
			setShowingInforWindow(false);
		}
	};

	const changeArrivalLimit = (event) => {
		setFromDate(moment(event).format("YYYY-MM-DD"));

		if (showingInfoWindow) {
			setActiveMarker(null);
			setShowingInforWindow(false);
		}
	};

	const onMarkerClick = (props, marker) => {
		setSelectedOrder(props.name);
		setActiveMarker(marker);
		setShowingInforWindow(true);
	};

	const onInfoWindowClose = () => {
		setActiveMarker(null);
		setShowingInforWindow(false);
	};

	const onMapClicked = () => {
		if (showingInfoWindow) {
			setActiveMarker(null);
			setShowingInforWindow(false);
		}
	};

	const onMapLoaded = (mapProps, map) => {
		map.setOptions({
			styles: mapStyles,
		});
	};

	let userMarkers = orderList.length
		? orderList.map((order, index) => {
        let markerIconUrl = require("../../assets/new-location-marker.png");
			let textColor = "#277203";

			if (Number(order.type) === 1) {
				markerIconUrl = require("../../assets/express-location-marker.png");
				textColor = "#ff0000";
			} else {
				if (order.status === 3) {
					markerIconUrl = require("../../assets/accepted-location-marker.png");
					textColor = "#ffa500";
				} else if (order.status === 4) {
					markerIconUrl = require("../../assets/packed-location-marker.png");
					textColor = "#b87333";
				} else if (order.status === 5) {
					markerIconUrl = require("../../assets/delivering-location-marker.png");
					textColor = "#d58a94";
				} else if (order.status === 6) {
					markerIconUrl = require("../../assets/delivered-location-marker.png");
					textColor = "#00c4cc";
				} else if (order.status === 8) {
					markerIconUrl = require("../../assets/arrived-location-marker.png");
					textColor = "#b048b5";
				}
        }

			let userMarker = (
				<Marker
            key={index}
            name={order}
            position={{
	            lat: order.list_customer_address.latitude,
	            lng: order.list_customer_address.long,
            }}
            icon={markerIconUrl}
            onClick={onMarkerClick}
            shouldRender={false}
				/>
			);
			order.shouldRender = false;
			return userMarker;
		})
		: null;

	// set time before call api
	let typingTimer; //timer identifier
	let doneTypingInterval = 750; //time in ms (7.5 seconds)
	const handleSearch = (value) => {
		if (showingInfoWindow) {
			setActiveMarker(null);
			setShowingInforWindow(false);
		}

		setIsSearching(true);
		clearTimeout(typingTimer);
		typingTimer = setTimeout(function () {
			if (value !== "") {
				let searchValue = parseInt(value.trim());
				const findOrder = orderList.find((x) => x.order_id === searchValue);
				if (findOrder) {
					console.log("found", findOrder);
					setMapZoom(18);
					setLatitude(findOrder.list_customer_address.latitude);
					setLongitude(findOrder.list_customer_address.long);
					setIsSearching(false);
				} else {
					setMapZoom(14);
					setLatitude(11.5564);
					setLongitude(104.9282);
					setIsSearching(false);
					alert("Order number not found!");
				}
			} else {
				setMapZoom(14);
				setLatitude(11.5564);
				setLongitude(104.9282);
				setIsSearching(false);
			}
		}, doneTypingInterval);
	};

	const handleSelect = (selectedList, selectedItem) => {
		setIsDisabled(true);
		if (selectedOptions.length > 0 && selectedOptions.includes(selectedItem)) {
			const updatedSelectedOptions = selectedOptions.filter(
				(option) => option !== selectedItem
			);
			setSelectedOptions(updatedSelectedOptions);
			filterMaxAndMinTime(updatedSelectedOptions);
		} else {
			setSelectedOptions(selectedList);
			filterMaxAndMinTime(selectedList);
		}
	};

	const handleRemove = (selectedList, removedItem) => {
		setIsDisabled(true);
		const updatedSelectedOptions = selectedOptions.filter(
			(option) => option !== removedItem
		);
		setSelectedOptions(updatedSelectedOptions);
		filterMaxAndMinTime(updatedSelectedOptions);
	};

	const filterMaxAndMinTime = (selectedList) => {
        if(selectedList.length > 0) {

            let minStart = selectedList[0].start;
            let maxEnd = selectedList[0].end;

            selectedList.forEach(item => {
                if (item.start < minStart) {
                    minStart = item.start;
                }
                if (item.end > maxEnd) {
                    maxEnd = item.end;
                }
            });
            setTimeOptions({minStart, maxEnd})
        }else{
            setTimeOptions({})
        }
    }

	const onMarkerClicks = (props, marker) => {
		setSelectedPlace({
			name: props.name,
			driverId: props.driverId,
		});
		setActiveMarkers(marker);
		// Deliberately not recentering -- clicking the pin just loads its context
		// (InfoWindow + logs panel). Use a log entry to actually move the map.
		setSelectedDriverLogs(props.driverLogs || []);
		setShowingInfoWindows(true);
		setShowDriverLogsModal(true)
	};

	const onCustomerMarkerClick = (props, marker) => {
		//  console.log("Here is your customer");
		console.log(`Here is my customer name`, props.userName);
		setActiveMarker(marker);
	};

	const handleApplyFilters = async () => {
		const isAllDriversSelected = selectedDrivers.length === driverInfo.length;

		const response = await API.getDriverListFiltered(
			isAllDriversSelected, // listAll = true if all selected
			isAllDriversSelected ? [] : selectedDrivers, // only send IDs if filtering
			fromDate,
			driverStartTime,
			driverEndTime
		);

		const result = await response.json();

		if (response.ok) {
			setDriverLocation(result.data.driver);
			setDriverInfo(result.data.driver)
			setWarehouse(result.data.warehouse);
		} else {
			console.error("Error applying filters", result?.message);
		}
	};


	const handleDriverChange = (driver, event) => {
		setSelectedDrivers((prev) =>
			prev.includes(driver)
				? prev.filter((d) => d !== driver)
				: [...prev, driver]
		);
	};
	//call driver location api
	const fetchDriverInfo = async (listAll = false) => {
		try {
			const isAllDriversSelected = selectedDrivers.length === driverInfo.length;
			const response = await API.getDriverListFiltered(
				listAll, // listAll = true if all selected
				isAllDriversSelected,
				fromDate,
				driverStartTime,
				driverEndTime
			);
			const result = await response.json();
			if (response.ok) {
				setDriverInfo(result.data.driver);
			}
		} catch (err) {
			console.log(err.message || "Network error");
		}
	};
	useEffect(() => {
		fetchDriverInfo();
	}, []);
	// fetchDriverInfo();

	const groupLogsByHour = (logs) => {
		const grouped = {};
		logs.forEach((log) => {
			const hourKey = moment(log.date).format('YYYY-MM-DD HH:00');
			if (!grouped[hourKey]) {
				grouped[hourKey] = [];
			}
			grouped[hourKey].push(log);
		});
		return grouped;
	};
    return (
        <Modal>
            <HelpPageWrapper>
                {/* =================================== Filter =============================*/}
                <Row>
                    <Col sm={3}>
                        <InputGroup className="mb-3">
                            <FormControl
                                size="md"
                                type="text"
                                placeholder="Search order number"
                                value={searchString}
                                onChange={(e) => setSearchString(e.target.value)}
                            />
                            <InputGroup.Append>
                                <Button variant="outline-secondary" onClick={() => handleSearch(searchString)}>Search</Button>
                            </InputGroup.Append>
                        </InputGroup>

                        {/*<Form.Control*/}
                            {/*style={{ width: "22rem" }}*/}
                            {/*size="md"*/}
                            {/*type="text"*/}
                            {/*placeholder="Search order number"*/}
                            {/*onChange={(e) => handleSearch(e.target.value)}*/}
                        {/*/>*/}
                    </Col>
                    <Col sm={3} style={{display: "inline-flex"}}>
                        <span style={{...labelStyle, width: "150px"}}>Delivery for the day:</span>&nbsp;&nbsp;
                        <Datetime style={{width: "300px"}}
                                  value={fromDate}
                                  dateFormat="YYYY-MM-DD"
                                  timeFormat={false}
                                  closeOnSelect={true}
                                  onChange={changeArrivalLimit}
                        />
                    </Col>
                    <Col sm={3}>
                        <MultiSelect
                            options={timeSlot}
                            selectedValues={selectedOptions}
                            onSelect={handleSelect}
                            onRemove={handleRemove}
                            showCheckbox={true}
                            disable={isDisabled}
                            placeholder="All times"
                            displayValue="label"
                            style={{
                                searchBox: {
                                    'max-height': '70px',
                                    'overflow-y': 'auto',
                                    'min-height': 'calc(1.5em + .75rem + 2px)',
                                    'background-color': '#fff',
                                    'padding' : '3px 5px 0px 5px'
                                }
                            }}
                        />
                    </Col>
                    <Col sm={3} className="d-flex justify-content-end">
                        <span style={{...labelStyle}}>Filter status: </span>
                        &nbsp;&nbsp;
                        <Form.Control
                            style={{width: "300px"}}
                            as="select"
                            onChange={(e) => handleSelectOrderStatus(e)}
                            value={selectedStatus}
                            disabled={isRequesting}
                        >
                            {orderStatusOpts.map((oStatus, index) => (
                                <option value={index} key={index}>
                                    {oStatus.label}{" "}
                                </option>
                            ))}
                        </Form.Control>
                    </Col>
                </Row>
	            {/* driver filter collapse */}
	            <div style={{textAlign: "left", position: "relative", top: "-45px"}}>
		            <Button
			            style={{marginTop: "15px"}}
			            onClick={() => setCollapse(!collapse)}
		            >
			            {collapse ? "Hide Driver location" : "Show Driver location"}
		            </Button>
		            <Collapse in={collapse}>
			            <div
				            style={{
					            padding: "1.5rem",
					            background: "#ffffff",
					            border: "1px solid #dee2e6",
					            borderRadius: "10px",
					            margin: "20px",
					            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
				            }}
			            >
				            <Row className="g-3">
					            {/* Drivers Filter */}
					            <Col md={2}>
						            <Form.Group>
							            <Form.Label>Drivers</Form.Label>
							            <Dropdown>
								            <Dropdown.Toggle variant="secondary" id="driverDropdown" className="w-100 text-truncate">
									            {selectedDrivers.length > 0
										            ? driverInfo
											            .filter((d) => selectedDrivers.includes(d.userId))
											            .map((d) => `${d.fist_name} ${d.last_name}`)
											            .join(", ")
										            : "Select Drivers"}
								            </Dropdown.Toggle>

								            <Dropdown.Menu
									            style={{padding: "10px", maxHeight: "250px", overflowY: "auto", width: "100%"}}>
									            <Form.Check
										            type="checkbox"
										            label="Select All"
										            checked={selectedDrivers.length === driverInfo.length}
										            onChange={(e) => {
											            if (e.target.checked) {
												            const allDriverIds = driverInfo.map((driver) => driver.userId);
												            setSelectedDrivers(allDriverIds);
											            } else {
												            setSelectedDrivers([]);
											            }
										            }}
										            style={{marginBottom: "8px", fontWeight: "bold"}}
									            />
									            <hr style={{margin: "8px 0"}}/>
									            {driverInfo.map((driver) => (
										            <Form.Check
											            key={driver.userId}
											            type="checkbox"
											            label={`${driver.fist_name} ${driver.last_name}`}
											            checked={selectedDrivers.includes(driver.userId)}
											            onChange={(e) => handleDriverChange(driver.userId, e)}
											            style={{marginBottom: "5px"}}
										            />
									            ))}
								            </Dropdown.Menu>
							            </Dropdown>
						            </Form.Group>
					            </Col>

					            {/* Delivery Time Filter */}
					            <Col md={4}>
						            <Form.Group>
							            {/*<Form.Label>Delivery Time Range</Form.Label>*/}
							            <Row className="g-2 align-items-end">
								            <Col xs={6} md={4}>
									            <Form.Label>From</Form.Label>
									            <Form.Control
										            type="time"
										            value={driverStartTime}
										            onChange={(e) => setDriverStartTime(e.target.value)}
										            placeholder="Start Time"
									            />
								            </Col>
								            <Col xs={6} md={4}>
									            <Form.Label>To</Form.Label>
									            <Form.Control
										            type="time"
										            value={driverEndTime}
										            onChange={(e) => setDriverEndTime(e.target.value)}
										            placeholder="End Time"
									            />
								            </Col>
								            <Col xs={12} md={4}>
									            <Button variant="primary" className="w-100" onClick={handleApplyFilters}>
										            Apply Filter
									            </Button>
								            </Col>
							            </Row>
						            </Form.Group>
					            </Col>
				            </Row>
			            </div>

		            </Collapse>
	            </div>

	            {/*end*/}
                <Row>
                    <Col sm={1}>
                        <img src={require("../../assets/new-location-marker.png")} onClick={(e) => onMarkerClick({position: {
                                lat: 11.5427,
                                lng: 104.932
                            }})}/>&nbsp;&nbsp;
                        <span style={labelStyle}>New</span>
                    </Col>
                    <Col sm={2}>
                        <img src={require("../../assets/accepted-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Accepted</span>
                    </Col>
                    <Col sm={2}>
                        <img src={require("../../assets/packed-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Packed</span>
                    </Col>
                    <Col sm={2}>
                        <img src={require("../../assets/delivering-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Delivering</span>
                    </Col>
                    <Col sm={2}>
                        <img src={require("../../assets/arrived-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Arrived</span>
                    </Col>
                    <Col sm={2}>
                        <img src={require("../../assets/delivered-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Delivered</span>
                    </Col>
                    <Col sm={1}>
                        <img src={require("../../assets/express-location-marker.png")}/>&nbsp;&nbsp;
                        <span style={labelStyle}>Express</span>
                    </Col>
                </Row>

                {/* =============================== Map =============================*/}
                <Row>
                    <div
                        style={{
                            width: "100%",
                            paddingTop: "10px",
                            marginBottom: "10px",
                            height: "88vh",
                            position: "relative",
                        }}
                    >
                        <Map
                            disableDefaultUI={true}
                            streetViewControl={false}
                            mapTypeControl={true}
                            keyboardShortcuts={false}
                            scrollwheel={false}
                            center={mapCenter}
                            google={window.google}
                            bounds={bounds}
                            style={{
                                width: "100%",
                                height: "80vh",
                            }}
                            draggable={true}
                            zoom={mapZoom}
                            initialCenter={mapCenter}
                            fullscreenControl={false}
                            zoomControl={true}
                            onClick={onMapClicked}
                            onReady={(mapProps, map) => onMapLoaded(mapProps, map)}
                        >
                            {
                               orderList.length? userMarkers: []
                            }

	                        <InfoWindow
		                        marker={activeMarker}
		                        onClose={onInfoWindowClose}
		                        visible={showingInfoWindow}
	                        >
		                        <div>
			                        <div>
				                        {selectedOrder && selectedOrder.order_id
					                        ? selectedOrder.order_id
					                        : ""}{" "}
				                        {selectedOrder && selectedOrder.customer_detail
					                        ? selectedOrder.customer_detail.name
					                        : ""}
			                        </div>
			                        {selectedOrder && selectedOrder.store_on_going_slot ? (
				                        <div>
					                        {moment(
						                        selectedOrder.store_on_going_slot.start_time,
						                        "YYYY-MM-DD hh:mm:ss"
					                        ).format("hh a")}{" "}
					                        -{" "}
					                        {moment(
						                        selectedOrder.store_on_going_slot.end_time,
						                        "YYYY-MM-DD hh:mm:ss"
					                        ).format("hh a")}
				                        </div>
			                        ) : (
				                        <div>ASAP</div>
			                        )}
		                        </div>
	                        </InfoWindow>
	                        {/* My custom Data  */}
	                        {warehouse && (
		                        <Marker
			                        position={{lat: warehouse.lat, lng: warehouse.lng}}
			                        title="Warehouse"
			                        icon={{
				                        url: require("../../assets/icons/stores.png"),
				                        scaledSize: new window.google.maps.Size(50, 50),
			                        }}
		                        />
	                        )}
	                        {Array.isArray(driverLocation) && driverLocation.length > 0 &&
		                        driverLocation.map((location, index) => {
			                        const driverLat = Number(location.lat);
			                        const driverLng = Number(location.lng);

			                        if (isNaN(driverLat) || isNaN(driverLng)) return null;

			                        const driverLogsPath = Array.isArray(location.location_logs)
				                        ? location.location_logs.map(log => ({lat: log.lat, lng: log.lng}))
				                        : [];
			                        const elements = [];
			                        const driverPosition = {
				                        lat: location.location_logs[0]?.lat || driverLat,
				                        lng: location.location_logs[0]?.lng || driverLng
			                        };

			                        // Driver marker
			                        elements.push(
				                        <Marker
					                        key={`driver-marker-${index}`}
					                        position={driverPosition}
					                        onClick={onMarkerClicks}
					                        driverLogs={location.location_logs}
					                        name={`${location.fist_name} ${location.last_name}`}
					                        driverId={location.userId}
					                        title={`Driver ${index + 1} ${location.fist_name} ${location.last_name}`}
					                        icon={{
						                        url: require("../../assets/icons/bike.png"),
						                        scaledSize: new window.google.maps.Size(32, 32),
					                        }}
				                        />
			                        );

			                        // Orders for this driver
			                        if (Array.isArray(location.orders) && location.orders.length) {
				                        location.orders.forEach((order, orderIndex) => {
					                        const customerPosition = {
						                        lat: order.customer.lat,
						                        lng: order.customer.lng,
					                        };

					                        // Customer icon
					                        let markerIconUrl = "";
					                        if (Number(order.type) === 1) {
						                        markerIconUrl = require("../../assets/express-location-marker.png");
					                        } else {
						                        switch (order.status) {
							                        case 3:
								                        markerIconUrl = require("../../assets/accepted-location-marker.png");
								                        break;
							                        case 4:
								                        markerIconUrl = require("../../assets/packed-location-marker.png");
								                        break;
							                        case 5:
								                        markerIconUrl = require("../../assets/delivering-location-marker.png");
								                        break;
							                        case 6:
								                        markerIconUrl = require("../../assets/delivered-location-marker.png");
								                        break;
							                        case 8:
								                        markerIconUrl = require("../../assets/arrived-location-marker.png");
								                        break;
							                        default:
								                        markerIconUrl = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
						                        }
					                        }

					                        // Polyline: driver logs (optional)
					                        if (driverLogsPath.length > 0) {
						                        elements.push(
							                        <Polyline
								                        key={`polyline-driverlogs-${index}-${orderIndex}`}
								                        path={[...[...driverLogsPath]?.reverse(), driverPosition, customerPosition]}
								                        options={{
									                        strokeColor: "#1E90FF",
									                        strokeOpacity: 0.8,
									                        strokeWeight: 3,
									                        zIndex: 9999,
									                        icons: [
										                        {
											                        icon: {
												                        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
												                        scale: 2,
												                        strokeColor: "#1E90FF",
											                        },
											                        offset: "100%", // or "50%" or "0%"
											                        repeat: "50px", // Arrow every 50px
										                        },
									                        ],
								                        }}
							                        />
						                        );
					                        }

					                        // Customer marker
					                        elements.push(
						                        <Marker
							                        key={`customer-marker-${index}-${orderIndex}`}
							                        onClick={onCustomerMarkerClick}
							                        position={customerPosition}
							                        title={`Customer for Driver ${location.fist_name}`}
							                        orderId={order.orderId}
							                        userName={order.customer.userName}
							                        deliveryDate={order.customer.deliveryDate}
							                        deliveryTime={order.customer.deliveryTime}
							                        icon={{url: markerIconUrl}}
						                        />
					                        );
				                        });
			                        } else {
				                        if (driverLogsPath.length > 0) {
					                        elements.push(
						                        <Polyline
							                        key={`polyline-driverlogs-${index}`}
							                        path={[...[...driverLogsPath]?.reverse(), driverPosition]}
							                        options={{
								                        strokeColor: "#033262",
								                        strokeOpacity: 0.8,
								                        strokeWeight: 3,
								                        zIndex: 9999,
								                        icons: [
									                        {
										                        icon: {
											                        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
											                        scale: 2,
											                        strokeColor: "#1E90FF",
										                        },
										                        offset: "100%", // or "50%" or "0%"
										                        repeat: "50px", // Arrow every 50px
									                        },
								                        ],
							                        }}
						                        />
					                        );
				                        }
			                        }

			                        return elements;
		                        })
	                        }

	                        <InfoWindow
		                        key={`driver-infowindow`}
		                        marker={activeMarkers}
		                        visible={showingInfoWindows}
		                        onClose={onInfoWindowClose}
	                        >
		                        <div>
			                        Driver {selectedPlace?.name}
			                        <br/>
			                        Driver ID: {selectedPlace?.driverId}
		                        </div>
	                        </InfoWindow>
	                        {driverMarkerPosition && (
		                        <Marker
			                        position={{lat: driverMarkerPosition.lat, lng: driverMarkerPosition.lng}}
			                        title={"Driver : " + selectedPlace?.name}
			                        icon={{
				                        url: require("../../assets/icons/mapIcon02.png"),
				                        scaledSize: new window.google.maps.Size(40, 40),
			                        }}
		                        />
	                        )}
                        </Map>
	                    {showDriverLogsModal && selectedDriverLogs.length && <Box
		                    position="absolute"
		                    bottom={65}
		                    left={10}
		                    width={290}
		                    height={500}
		                    zIndex={2000}
	                    >
		                    <Paper
			                    style={{
				                    height: '100%',
				                    overflowY: 'auto',
				                    padding: '8px 12px',
			                    }}
			                    elevation={1}
		                    >
			                    <IconButton
				                    style={{position: 'absolute', top: 4, right: 4}}
				                    size="small"
				                    onClick={() => {
					                    setShowDriverLogsModal(false)
					                    setDriverMarkerPosition(null)
				                    }}
			                    >
				                    <CloseIcon/>
			                    </IconButton>
			                    <Typography variant="h6" gutterBottom>
				                    Driver Logs
			                    </Typography>

			                    {Object.keys(groupLogsByHour(selectedDriverLogs)).length === 0 ? (
				                    <Typography variant="body2" color="textSecondary">
					                    No logs available
				                    </Typography>
			                    ) : (
				                    Object.entries(groupLogsByHour(selectedDriverLogs)).map(([hour, logs], groupIdx) => (
					                    <ExpansionPanel key={groupIdx} defaultExpanded={groupIdx === 0}>
						                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
							                    <Typography variant="subtitle2">
								                    {moment(hour).format('MMM D, YYYY HH:00')}
							                    </Typography>
						                    </ExpansionPanelSummary>
						                    <ExpansionPanelDetails style={{padding: 0}}>
							                    <List dense style={{width: '100%'}}>
								                    {logs.map((log, i) => (
									                    <ListItem
										                    key={i}
										                    button
										                    onClick={() => {
											                    setDriverMarkerPosition({lat: log.lat, lng: log.lng})
											                    setLatitude(log.lat)
											                    setLongitude(log.lng)
										                    }
										                    }
									                    >
										                    <ListItemText
											                    primary={moment(log.date).format('hh:mm:ss A')}
											                    secondary={`Lat: ${log.lat.toFixed(4)}, Lng: ${log.lng.toFixed(4)}`}
										                    />
									                    </ListItem>
								                    ))}
							                    </List>
						                    </ExpansionPanelDetails>
					                    </ExpansionPanel>
				                    ))
			                    )}
		                    </Paper>
	                    </Box>}
                    </div>
                </Row>
            </HelpPageWrapper>
        </Modal>
    );
};

export default OrderMap;
